module.exports = __webpack_public_path__ + "img/dateEle.d16afdbf.svg";